import '../assets/NcCheckboxRadioSwitch-D5gP42gi.css';
import { r as register } from "./_l10n-B4dEPXsr.mjs";
register();
